import { Palette } from '@mui/material/styles';
import { FontSize } from '@store/types/UserStoreSlice.type';
import { isDarkPagePalette } from '@theme/palettes/getPalette';
import { fontWeights, getTypographyVariants } from '@theme/styleOverrides/typography';

const MuiOutlinedInput = ({ fontSize }: { fontSize: FontSize }) => ({
  styleOverrides: {
    root: {
      input: {
        ...getTypographyVariants(fontSize).bodySmall,
      },
      textarea: {
        ...getTypographyVariants(fontSize).bodySmall,
      },
    },
  },
});

const MuiTextField = ({ fontSize }: { fontSize: FontSize }) => ({
  styleOverrides: {
    root: {
      ...getTypographyVariants(fontSize).bodySmall,
    },
  },
});

const MuiFormHelperText = ({ fontSize }: { fontSize: FontSize }) => ({
  styleOverrides: {
    root: {
      ...getTypographyVariants(fontSize).caption,
      fontWeight: fontWeights.default,
      marginLeft: '0px',
      marginTop: '4px',
      position: 'relative',
      margin: '0 0 2px 0',
      transform: 'initial',
      zIndex: '0',
      '&.Mui-error': {
        color: 'error.main',
      },
    },
  },
});

const MuiInputLabel = ({ fontSize }: { fontSize: FontSize }) => ({
  styleOverrides: {
    root: {
      ...getTypographyVariants(fontSize).bodySmall,
      marginBottom: '2px',
      position: 'relative',
      margin: '0 0 2px 0',
      transform: 'initial',
      zIndex: '0',

      '& .Mui-error': {
        color: 'error.main',
      },
    },
    '& .MuiInputLabel-root': {
      color: 'text.caption',
      '& .Mui-error': {
        color: 'error.main',
      },
      '& .Mui-disabled': {
        color: 'text.disabled',
      },
    },
  },
});

const MuiFormLabel = ({ palette, fontSize }: { palette: Palette; fontSize: FontSize }) => ({
  styleOverrides: {
    root: {
      ...getTypographyVariants(fontSize).bodySmall,
      marginBottom: '2px',

      // the focused label is drawn in primary, which is the page navy on dark page palettes, so it disappears
      ...(isDarkPagePalette(palette) && { '&.Mui-focused:not(.Mui-error)': { color: palette.text.main } }),
      '&.Mui-error': {
        color: 'error.main',
      },
    },
  },
});

export { MuiOutlinedInput, MuiTextField, MuiFormHelperText, MuiInputLabel, MuiFormLabel };
